<template>
  <div id="client_complete">
    <dd-header />
    <div class="wrapper">
      <div class="main_content">
        <dd-menu ref="menuRef"/>
        <div id="payment_service">
          <dd-sitemap
            :pageKey="pageKey"
            :pageList="pageList"
            :mapStyle="'topic_path'"
          />
          <section id="president_msg">
            <h2>事業者様向け「後払い」サービスのご案内</h2>
            <p>
              SEIKYU＋は事業者様向けの後払いサービスです。
            </p>
            <div class="payment_guide_img2"><a href="https://bizforward.co.jp/seikyuplus/buyer/top" target="_blank"><img :src="getImage('top/payment/seikyuplus_01.jpg')"></a></div>
            <div class="payment_guide_img"><img :src="getImage('top/payment/seikyuplus_03.png')"></div>
          </section>
          <section>
            <div>お支払いサイクルについて</div>
            <p>納品日の当月末日締めにてご請求書を発行、お支払い期限は翌月末日となります。</p>
          </section>
          <section>
            <div>お申し込みからサービス開始までの流れ</div>
            <p>
              お申し込み受付後、株式会社Biz Forwardにて審査が行われます。<br>
              審査及び利用開始のお手続きについて、審査にお日にちがかかる場合がございます<br>
              審査通過のご連絡をもって後払いサービスをご利用いただけます。<br>
              請求書は株式会社Biz Forwardから発行され、メールにて送付させていただきます。<br>
              銀行振込手数料は、貴社ご負担となります。
            </p>
          </section>
          <section>
            <div v-bind:class="{detail_btn8: true, btn_pos_center: true, disabled: !isCorpLogin}" @click="confirm">お申込みはこちら</div>
            <p class="right">※株式会社Biz Forwardの審査によりご希望に添えない場合もございますので予めご了承ください。</p>
          </section>
          <section>
            <div>お問い合わせ</div>
            <div><a href="tel:0362761123"><img :src="getImage('bunner/TEL.webp')"></a></div>
          </section>
        </div>
      </div>
    </div>
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
  </div>
</template>

<script>
import axios from 'axios'
import * as Api from '../../utils/Api'
import * as App from '../../utils/App'
import {DC_URL, DC_STORAGE_KEY} from '../../constants/App'
import LoadingModal from '../../components/common/LoadingModal'
import Header from '../components/common/DcHeader'
import LeftMenu from '../components/top/DcLeftMenu'
import Footer from '../components/common/DcFooter'
import SiteMap from '../components/common/DcSiteMap'

export default {
  name: 'DcPaymentService',
  components: {
    'dd-header': Header,
    'dd-menu': LeftMenu,
    'dd-footer': Footer,
    'dd-sitemap': SiteMap,
    'dd-loading-modal': LoadingModal
  },
  data () {
    return {
      pageKey: 'dcPaymentService',
      pageList: [
        {id: 'top', key: 'dcTop', title: 'トップページ', route: 'DcTop'},
        {id: 'corpInformation', key: 'dcCorpInformation', title: 'ご購入ガイド', route: 'DcCorpInformation'},
        {id: 'paymentService', key: 'dcPaymentService', title: '', route: 'DcPaymentService'}
      ],
      user: {},
      confirmFlag: false
    }
  },
  computed: {
    isCorpLogin: function () {
      if (!this.user || Object.keys(this.user).length <= 0) return false
      if (this.user.userId === undefined) return false
      if (this.user.userLevel === 2) return true
      if (this.user.userLevel === 1) return true
      return false
    }
  },
  methods: {
    getImage: function (image) {
      return App.getMmstyleResource(image)
    },
    route: function (name, params) {
      this.$router.push({
        name: name,
        query: params
      })
    },
    confirm: function () {
      this.confirmFlag = true
      this.$refs.loadingModalRef.showModal(true)
      axios.get(DC_URL.TOP + '/check-client')
        .then(response => {
          if (response.data.errorMessage) {
            App.showModal({
              messages: [response.data.errorMessage]
            })
          } else {
            this.route('DcClientInput')
          }
        }).catch(error => {
          this.validateErrorMessages = {}
          Api.handleError(error, this.errorMessage, this.validateErrorMessages)
          this.$router.push('/error')
        }).finally(() => {
          this.confirmFlag = false
          this.$refs.loadingModalRef.showModal(false)
        })
    }
  },
  watch: {
  },
  mounted () {
    this.user = App.getLocalStorage(DC_STORAGE_KEY.USER_INFO)
  },
  created () {
  }
}
</script>
<style src="../css/dctop4.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/hakotan/pages/DcPaymentService.vue